import React from 'react'
import currency from 'i18n/currency'
import { Button, ListGroup, ListGroupItem } from 'reactstrap'
import time from 'i18n/time'
import { useTimer } from 'react-timer-hook'
import { useTranslation } from 'react-i18next'
import { groupBy } from 'lodash'
import { isBrowser, isMobile } from 'react-device-detect'
import ApiFetcher from 'lib/api_fetcher'

const CartSummary = (props) => {
  const { cart, params, setOpen } = props
  const urls = params && params.urls
  const { i18n } = useTranslation()

  const fetchDiscardCart = (discardResource) => {
    PubSub.publish('loading-page')
    new ApiFetcher({
      key: 'cart',
      endpoint: discardResource.url,
      method: discardResource.method,
    })
      .call()
      .then(() => {
        setOpen(false)
        PubSub.publish('loaded-page')
        location.reload()
      })
  }

  const fetchDiscardReservation = (reservation_id, discardReservationResource) => {
    PubSub.publish('loading-page')
    new ApiFetcher({
      key: 'cart',
      endpoint: discardReservationResource.url.replace(/ *\:[^)]*\: */g, reservation_id),
      method: discardReservationResource.method,
    })
      .call()
      .then(() => {
        setOpen(false)
        PubSub.publish('loaded-page')
        location.reload()
      })
  }

  const CartTimer = ({ expiryTimestamp }) => {
    const { minutes, hours, days } = useTimer({ expiryTimestamp })

    if (hours > 0 || days > 0) return null

    return (
      <div className="text-center">
        <div>
          <div className="fs-5">{i18n.t('cart_summary.expiration_time')}</div>
          <div className="fs-4 fw-bold">
            <span>{minutes}</span>m
          </div>
        </div>
      </div>
    )
  }

  const CartWithProducts = () => {
    const expiryDate = time(cart.expires_at).toDate()

    return (
      <>
        <ListGroup>
          {cart.items.map((item) => {
            const { id, product, event, tickets, price_display_mode } = item
            const { start_date, show_date, show_time } = event

            const ticketGroups = Object.values(groupBy(tickets, ({ ticket_type_code }) => ticket_type_code)).map(
              (group) => ({
                ...group[0],
                title: `${group.length}x ${group[0].title}`,
                total_price: group.reduce((acc, ticket) => acc + parseFloat(ticket.total_price), 0),
                currency: group[0].currency,
              })
            )

            return (
              <div key={id} className="mb-3">
                <div className="d-flex justify-content-between bg-light border border-bottom-0 rounded-top p-3">
                  <div>
                    <strong>{product.title}</strong>
                    {show_date && (
                      <div>
                        <i>{time(start_date).format(show_time ? 'LLL' : 'LL')}</i>
                      </div>
                    )}
                  </div>

                  {cart.edit_status !== 'locked' && (
                    <div>
                      <i
                        className="fa fa-trash"
                        role="button"
                        onClick={() => {
                          if (cart.items.length > 1) {
                            fetchDiscardReservation(id, params.urls.discard_reservation)
                          } else {
                            fetchDiscardCart(params.urls.discard)
                          }
                        }}
                      />
                    </div>
                  )}
                </div>

                {ticketGroups.map(({ id, title, total_price, currency: curr }) => (
                  <ListGroupItem key={id} className="d-flex justify-content-between">
                    <div>{title}</div>
                    {price_display_mode !== 'hidden_price' && (
                      <div>{currency(total_price, curr).format()}</div>
                    )}
                  </ListGroupItem>
                ))}
              </div>
            )
          })}
        </ListGroup>

        <div className="d-flex justify-content-between fw-bold mt-2">
          <div>{i18n.t('cart_summary.total_price')}</div>
          <div>{cart.final_price_label}</div>
        </div>

        <hr />

        <CartTimer expiryTimestamp={expiryDate} />

        <div
          role="button"
          className="text-center fw-medium mt-2"
          onClick={() => {
            if (confirm('¿Está seguro que quiere cancelar la reserva?')) {
              fetchDiscardCart(params.urls.discard)
            }
          }}
        >
          <i className="fa fa-trash me-2" />
          {i18n.t('cart_summary.discard_cart')}
        </div>

        <hr />

        <Button
          href={urls && urls.buyer_step}
          color="primary"
          className="w-100 text-white mt-3 text-uppercase fw-bold"
        >
          {i18n.t('cart_summary.link_to_reservation')}
        </Button>
      </>
    )
  }

  const EmptyCart = () => (
    <div className="text-center">
      <hr />
      <i>{i18n.t('cart_summary.without_reservations_alert')}</i>
    </div>
  )

  return (
    <div
      style={{
        position: 'absolute',
        top: isBrowser ? '15px' : '55px',
        right: '15px',
        background: 'white',
        zIndex: '99999',
        width: '315px',
      }}
      className="p-3 shadow rounded"
    >
      <h4 className="mb-3 d-flex justify-content-between align-items-center">
        <div>{i18n.t('cart_summary.cart')}</div>
        <i
          className="fa fa-times-circle text-muted"
          role="button"
          onClick={() => setOpen(false)}
        />
      </h4>

      {cart ? <CartWithProducts /> : <EmptyCart />}
    </div>
  )
}

export default CartSummary
